module.exports = __webpack_public_path__ + "static/page-bg.22a6de82.png";